module.exports = __webpack_public_path__ + "img/ideal.48a7c0b6.svg";